import { history } from 'app';
function routeForward(path) {
    history.push(path, { routeBackLocation: history.location });
}
export default routeForward;
